export interface Attachment {
  _id?: string;
  downloadUrl?: string;
  name?: string;
  type?: AttachmentType;
  size?: Number;
  file?: File
}

export enum AttachmentType {
  VIDEO = "video",
  IMAGE = "image",
  AUDIO = "audio",
}
